import React from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { formatDate } from '../../lib/utils';
import { Plus } from 'lucide-react';

export default function AdminUsers({ 
  users, 
  organizations,
  onCreateUser, 
  onDeleteUser 
}) {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          Users
        </h2>
        <Button onClick={onCreateUser} className="btn-primary rounded-none" data-testid="create-user-btn">
          <Plus className="w-4 h-4 mr-2" />
          Create User
        </Button>
      </div>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Organization</th>
              <th>Created</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map(user => {
              const org = organizations.find(o => o.id === user.org_id);
              return (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.email}</td>
                  <td>
                    <Badge variant="outline" className="rounded-none">
                      {user.role}
                    </Badge>
                  </td>
                  <td>{org?.display_name || '-'}</td>
                  <td>{formatDate(user.created_at)}</td>
                  <td>
                    {user.role !== 'admin' && (
                      <Button variant="ghost" size="sm" onClick={() => onDeleteUser(user.id)} className="text-red-600" data-testid={`delete-user-${user.id}`}>
                        Delete
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
